import moment from "moment-timezone";
import i18n from "../i18n";

const DATE_FORMAT = {
  date: "YYYY-MM-DD",
  datetime: "YYYY-MM-DD HH:mm:ss",
};

const getCurrentTimezone = () => moment.tz.guess();

const getCurrentDateMoment = () => moment();

const getCurrentTimestamp = (): number => getCurrentDateMoment().valueOf();

const getDateFormat = () => i18n.t("date.format") as string;

const timestampToMoment = (timestamp: null | number | string) => moment(timestamp ? +timestamp : undefined);

const timestampToDateString = (timestamp: number | string, format = getDateFormat()) => timestampToMoment(timestamp).format(format);

const dateToMoment = (date: string, format = DATE_FORMAT.date) => moment(date, format);

const timestampToUtcTimestamp = (timestamp: number) => moment.utc(timestampToDateString(timestamp, DATE_FORMAT.datetime));

const convertToFirestoreMoment = (timestamp: number) => moment.utc(timestampToDateString(timestamp, DATE_FORMAT.datetime));

const convertToLocalMoment = (timestamp: number) => dateToMoment(moment.utc(timestamp).format(DATE_FORMAT.datetime), DATE_FORMAT.datetime);

export {
  DATE_FORMAT,
  getCurrentTimezone,
  getCurrentDateMoment,
  getCurrentTimestamp,
  getDateFormat,
  timestampToMoment,
  timestampToDateString,
  timestampToUtcTimestamp,
  dateToMoment,
  convertToFirestoreMoment,
  convertToLocalMoment,
};
